export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          联系我们
        </h2>
        <p className="mt-2 text-sm text-foreground-500">
          意见反馈 · 资源建议 · 商务合作
        </p>
        <div className="mt-8 p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            如果您在使用过程中有任何意见或建议，或者希望我们添加特定电视剧资源，
            欢迎通过以下方式与我们取得联系。我们会认真对待每一条反馈，持续优化追剧体验。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:feedback@kuaikanys.com"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              发送邮件反馈
            </a>
            <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300/60 text-foreground-600 font-medium text-sm whitespace-nowrap">
              <i className="ri-wechat-line"></i>
              微信公众号：快看影视
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}